module.exports = __webpack_public_path__ + "assets/img/19.1c172db2.png";